import { Box } from '@mui/material';
import type { HomeBannerRow } from '../home-banners.hook';

type Props = {
    banner: HomeBannerRow;
    scale?: number;
};

export default function BannerComposition({ banner, scale = 1 }: Props) {
    const width = 320 * scale;
    const height = 180 * scale;
    const gap = 0.5 * scale;

    const renderImage = (index: number, imageWidth?: number, imageHeight?: number) => {
        const imageUrl = banner.images?.[index]?.url;

        return (
            <Box
                sx={{
                    bgcolor: 'grey.100',
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: `${8 * scale}px`,
                    boxSizing: 'border-box',
                    height: imageHeight || '100%',
                    overflow: 'hidden',
                    position: 'relative',
                    width: imageWidth || '100%',
                    minHeight: 0,
                    minWidth: 0,
                }}
            >
                {typeof imageUrl === 'string' && imageUrl && (
                    <Box
                        component="img"
                        src={imageUrl}
                        alt={`Banner ${index + 1}`}
                        sx={{ display: 'block', height: 1, maxHeight: '100%', maxWidth: '100%', objectFit: 'cover', width: 1 }}
                    />
                )}
            </Box>
        );
    };

    if (banner.type === 'two-images') {
        return (
            <Box sx={{ display: 'grid', gap, gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', height, minHeight: 0, minWidth: 0, overflow: 'hidden', width }}>
                {renderImage(0, undefined, height)}
                {renderImage(1, undefined, height)}
            </Box>
        );
    }

    if (banner.type === 'three-images') {
        return (
            <Box sx={{ display: 'grid', gap, gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', height, minHeight: 0, minWidth: 0, overflow: 'hidden', width }}>
                {renderImage(0, undefined, height)}
                <Box sx={{ display: 'grid', gap, gridTemplateRows: 'repeat(2, minmax(0, 1fr))', minHeight: 0, minWidth: 0, overflow: 'hidden' }}>
                    {renderImage(1)}
                    {renderImage(2)}
                </Box>
            </Box>
        );
    }

    return <Box sx={{ height, minHeight: 0, minWidth: 0, overflow: 'hidden', width }}>{renderImage(0, width, height)}</Box>;
}
